export enum LocalStorageKey {
	IS_CALENDAR_SUB_HEAD_OPEN = "PLANNING_BOARD_calendarSubHead_isOpen",
	IS_RESIZE_TUTORIAL_COMPLETED = "PLANNING_BOARD_tutorial_isResizeCompleted",
	IS_DND_TUTORIAL_COMPLETED = "PLANNING_BOARD_tutorial_isDndCompleted",
	IS_DND_SCHEDULE_GROUP_ITEM_TUTORIAL_COMPLETED = "PLANNING_BOARD_tutorial_isDndScheduleGroupItemCompleted",
	IS_SORT_SCHEDULE_GROUPS_TUTORIAL_COMPLETED = "PLANNING_BOARD_tutorial_isSortScheduleGroupsCompleted",
	SHOW_ONLY_SCHEDULED_MEMBERS = "PLANNING_BOARD_showOnlyScheduledMembers",
}

export interface IsCalendarSubHeadOpen {
	schedulePhases: boolean;
	employees: boolean;
	resources: boolean;
	[id: string]: boolean;
}

export type SetIsCalendarSubHeadOpen = (
	scheduleGroupId: string,
	nextIsOpen: boolean
) => void;
